import React from "react";
import Footer from "../../components/Footer/Footer";
import Header from "../../components/Header/Header";
import "../../assets/css/Shop.css";
import {
	arrival1,
	arrival2,
	arrival3,
	arrival7,
	arrival8,
	arrival9,
	seller1,
} from "../../constants";

const Shop = () => {
	return (
		<>
			{/* Header starts here */}
			<Header />
			{/* Header ends here */}
			{/* Page Header starts here */}
			<section className="pageheader">
				<div className="container">
					<div className="row">
						<div className="col-lg-12">
							<div className="content-wrapper">
								<h5>Fresh Beer 100%</h5>
								<h2>Poseidon</h2>
								<h6>Moringa</h6>
								<h3>$299</h3>
								<a href="#" className="btn">
									Shop Now
								</a>
							</div>
						</div>
					</div>
				</div>
			</section>
			{/* Page Header ends here */}
			{/* products starts here */}
			<section className="product-sec">
				<div className="container">
					<div className="row foods-row">
						<div className="col-lg-3">
							<div className="heading-wrapper">
								<h2>Frozen Seafoods</h2>
							</div>
						</div>
						<div className="col-lg-9">
							<div className="sort-wrapper">
								<ul>
									<li>
										<div className="sort-field-wrapper">
											<label htmlFor="Sortby">Sort by:</label>
											<select name="" className="form-control" id="">
												<option value="Sort by popularity" disabled selected>
													Sort by popularity
												</option>
											</select>
										</div>
									</li>
									<li>
										<span>view</span>
									</li>
									<li>
										<a href="#">
											<i className="fa fa-bars" aria-hidden="true"></i>
										</a>
									</li>
									<li>
										<a href="#">
											<i className="fa fa-th-large" aria-hidden="true"></i>
										</a>
									</li>
								</ul>
							</div>
						</div>
					</div>
					<div className="row">
						<div className="col-lg-3">
							<div className="sidebars-wrapper">
								<div className="heading-wrapper">
									<h4>SUB CATEGORIES</h4>
								</div>
								<div className="categories-sidebar-wrapper">
									<div className="accordion" id="accordionExample">
										<div className="cat-name">
											<ul>
												<li>
													<a href="#">
														<span>All </span>
														<span className="total-cat">167</span>
													</a>
												</li>
											</ul>
										</div>
										<div className="accordion-item">
											<h2 className="accordion-header" id="headingTwo">
												<button
													className="accordion-button collapsed"
													type="button"
													data-bs-toggle="collapse"
													data-bs-target="#collapseTwo"
													aria-expanded="false"
													aria-controls="collapseTwo"
												>
													<span>Food</span>
													{/* <span className="total-category">167</span> */}
												</button>
											</h2>
											<div
												id="collapseTwo"
												className="accordion-collapse collapse"
												aria-labelledby="headingTwo"
												data-bs-parent="#accordionExample"
											>
												<div className="accordion-body">
													<ul>
														<li>
															<a href="#">Chocolate and snacks</a>
														</li>
														<li>
															<a href="#">Food cupboard</a>
														</li>
														<li>
															<a href="#">Fresh</a>
														</li>
														<li>
															<a href="#">Frozen</a>
														</li>
														<li>
															<a href="#">Drinks</a>
														</li>
													</ul>
												</div>
											</div>
										</div>
										<div className="cat-name">
											<ul>
												<li>
													<a href="#">
														<span>Bath & body </span>
													</a>
												</li>
												<li>
													<a href="#">
														<span>Health & Beauty</span>
													</a>
												</li>
												<li>
													<a href="#">
														<span>Baby, Child & Parent</span>
													</a>
												</li>
												<li>
													<a href="#">
														<span>Homeware</span>
													</a>
												</li>
												<li>
													<a href="#">
														<span>Pets</span>
													</a>
												</li>
											</ul>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div className="col-lg-9">
							<div className="row">
								<div className="col-lg-3 px-0">
									<div className="product-card-wrapper">
										<div className="product-img-wrapper">
											<a href="/product">
												<figure>
													<img src={arrival3} className="img-fluid" alt="" />
												</figure>
											</a>
										</div>
										<div className="product-content-wrapper">
											<h5>Brand Name</h5>
											<span className="ice">Asia Green Bananas</span>
											<div className="rating-wrapper">
												<ul>
													<li>
														<i className="fa fa-star"></i>
													</li>
													<li>
														<i className="fa fa-star"></i>
													</li>
													<li>
														<i className="fa fa-star"></i>
													</li>
													<li>
														<i className="fa fa-star"></i>
													</li>
													<li>
														<i className="fa fa-star"></i>
													</li>
													<li className="total-rating">
														<span>(1)</span>
													</li>
												</ul>
											</div>
											<h6>5kg</h6>
											<h4>$19.25</h4>

											<div className="counter-total-wrapper">
												<input type="number" min={0} />
												<h6>
													Total: <span>$38.5</span>
												</h6>
											</div>
											<a href="/Product-cart" className="btn">
												Add To Cart
											</a>
										</div>
									</div>
								</div>
								<div className="col-lg-3 px-0">
									<div className="product-card-wrapper">
										<div className="product-img-wrapper">
											<figure>
												<img src={arrival2} className="img-fluid" alt="" />
											</figure>
										</div>
										<div className="product-content-wrapper">
											<h5>Farmart</h5>
											<span className="ice">
												British Beef Mine (Typically 10% Fat)
											</span>
											<div className="rating-wrapper">
												<ul>
													<li>
														<i className="fa fa-star"></i>
													</li>
													<li>
														<i className="fa fa-star"></i>
													</li>
													<li>
														<i className="fa fa-star"></i>
													</li>
													<li>
														<i className="fa fa-star"></i>
													</li>
													<li>
														<i className="fa fa-star"></i>
													</li>
													<li className="total-rating">
														<span>(6)</span>
													</li>
												</ul>
											</div>
											<h6>454g</h6>
											<h4>$96.90</h4>

											<div className="counter-total-wrapper">
												<input type="number" min={0} />
												<h6>
													Total: <span>$96.90</span>
												</h6>
											</div>
											<a href="#" className="btn">
												Add To Cart
											</a>
										</div>
									</div>
								</div>
								<div className="col-lg-3 px-0">
									<div className="product-card-wrapper">
										<div className="product-img-wrapper">
											<figure>
												<img src={arrival7} className="img-fluid" alt="" />
											</figure>
											<div className="save-wrapper">
												<h6>Save 12%</h6>
											</div>
										</div>
										<div className="product-content-wrapper">
											<h5>MartFury</h5>
											<span className="ice">US Yellow Water Melon</span>
											<div className="rating-wrapper">
												<ul>
													<li>
														<i className="fa fa-star"></i>
													</li>
													<li>
														<i className="fa fa-star"></i>
													</li>
													<li>
														<i className="fa fa-star"></i>
													</li>
													<li>
														<i className="fa fa-star"></i>
													</li>
													<li>
														<i className="fa fa-star"></i>
													</li>
													<li className="total-rating">
														<span>(2)</span>
													</li>
												</ul>
											</div>
											<h6>2kg</h6>
											<h4>
												<span style={{ color: "#FA532C" }}>$59.50 </span>
												<strike style={{ color: "#666666", FontSize: "12px" }}>
													{" "}
													$69.70
												</strike>
											</h4>

											<div className="counter-total-wrapper">
												<input type="number" min={0} />
												<h6>
													Total: <span>$38.5</span>
												</h6>
											</div>
											<a href="#" className="btn">
												Add To Cart
											</a>
										</div>
									</div>
								</div>
								<div className="col-lg-3 px-0">
									<div className="product-card-wrapper">
										<div className="product-img-wrapper">
											<figure>
												<img src={arrival8} className="img-fluid" alt="" />
											</figure>
											<div className="save-wrapper">
												<h6>Save 34%</h6>
											</div>
										</div>
										<div className="product-content-wrapper">
											<h5>Farmart</h5>
											<span className="ice">Spicies Snacks 6 Ready Salted</span>
											<div className="rating-wrapper">
												<ul>
													<li>
														<i className="fa fa-star"></i>
													</li>
													<li>
														<i className="fa fa-star"></i>
													</li>
													<li>
														<i className="fa fa-star"></i>
													</li>
													<li>
														<i className="fa fa-star"></i>
													</li>
													<li>
														<i className="fa fa-star"></i>
													</li>
													<li className="total-rating">
														<span>(2)</span>
													</li>
												</ul>
											</div>
											<h6>100g</h6>
											<h4>
												<span style={{ color: "#FA532C" }}>$2.5 </span>
												<strike style={{ color: "#666666", FontSize: "12px" }}>
													$7.5
												</strike>
											</h4>

											<div className="counter-total-wrapper">
												<input type="number" min={0} />
												<h6>
													Total: <span>$38.5</span>
												</h6>
											</div>
											<a href="#" className="btn">
												Add To Cart
											</a>
										</div>
									</div>
								</div>
								<div className="col-lg-3 px-0">
									<div className="product-card-wrapper">
										<div className="product-img-wrapper">
											<figure>
												<img src={arrival8} className="img-fluid" alt="" />
											</figure>
										</div>
										<div className="product-content-wrapper">
											<h5>Farmart</h5>
											<span className="ice">
												British Beef Mine (Typically 10% Fat)
											</span>
											<div className="rating-wrapper">
												<ul>
													<li>
														<i className="fa fa-star"></i>
													</li>
													<li>
														<i className="fa fa-star"></i>
													</li>
													<li>
														<i className="fa fa-star"></i>
													</li>
													<li>
														<i className="fa fa-star"></i>
													</li>
													<li>
														<i className="fa fa-star"></i>
													</li>
													<li className="total-rating">
														<span>(1)</span>
													</li>
												</ul>
											</div>
											<h6>454kg</h6>
											<h4>$96.90</h4>

											<div className="counter-total-wrapper">
												<input type="number" min={0} />
												<h6>
													Total: <span>$96.90</span>
												</h6>
											</div>
											<a href="#" className="btn">
												Add To Cart
											</a>
										</div>
									</div>
								</div>
								<div className="col-lg-3 px-0">
									<div className="product-card-wrapper">
										<div className="product-img-wrapper">
											<figure>
												<img src={arrival9} className="img-fluid" alt="" />
											</figure>
										</div>
										<div className="product-content-wrapper">
											<h5>Farmart</h5>
											<span className="ice">
												British Beef Mine (Typically 10% Fat)
											</span>
											<div className="rating-wrapper">
												<ul>
													<li>
														<i className="fa fa-star"></i>
													</li>
													<li>
														<i className="fa fa-star"></i>
													</li>
													<li>
														<i className="fa fa-star"></i>
													</li>
													<li>
														<i className="fa fa-star"></i>
													</li>
													<li>
														<i className="fa fa-star"></i>
													</li>
													<li className="total-rating">
														<span>(1)</span>
													</li>
												</ul>
											</div>
											<h6>454g</h6>
											<h4>$96.90</h4>

											<div className="counter-total-wrapper">
												<input type="number" min={0} />
												<h6>
													Total: <span>$96.90</span>
												</h6>
											</div>
											<a href="#" className="btn">
												Add To Cart
											</a>
										</div>
									</div>
								</div>
								<div className="col-lg-3 px-0">
									<div className="product-card-wrapper">
										<div className="product-img-wrapper">
											<figure>
												<img src={arrival2} className="img-fluid" alt="" />
											</figure>
											<div className="save-wrapper">
												<h6>Save 12%</h6>
											</div>
										</div>
										<div className="product-content-wrapper">
											<h5>MartFury</h5>
											<span className="ice">US Yellow Water Melon</span>
											<div className="rating-wrapper">
												<ul>
													<li>
														<i className="fa fa-star"></i>
													</li>
													<li>
														<i className="fa fa-star"></i>
													</li>
													<li>
														<i className="fa fa-star"></i>
													</li>
													<li>
														<i className="fa fa-star"></i>
													</li>
													<li>
														<i className="fa fa-star"></i>
													</li>
													<li className="total-rating">
														<span>(2)</span>
													</li>
												</ul>
											</div>
											<h6>2kg</h6>
											<h4>
												<span style={{ color: "#FA532C" }}>$59.50 </span>
												<strike style={{ color: "#666666", FontSize: "12px" }}>
													{" "}
													$69.70
												</strike>
											</h4>

											<div className="counter-total-wrapper">
												<input type="number" min={0} />
												<h6>
													Total: <span>$38.5</span>
												</h6>
											</div>
											<a href="#" className="btn">
												Add To Cart
											</a>
										</div>
									</div>
								</div>
								<div className="col-lg-3 px-0">
									<div className="product-card-wrapper">
										<div className="product-img-wrapper">
											<figure>
												<img src={arrival3} className="img-fluid" alt="" />
											</figure>
											<div className="save-wrapper">
												<h6>Save 34%</h6>
											</div>
										</div>
										<div className="product-content-wrapper">
											<h5>Farmart</h5>
											<span className="ice">Spicies Snacks 6 Ready Salted</span>
											<div className="rating-wrapper">
												<ul>
													<li>
														<i className="fa fa-star"></i>
													</li>
													<li>
														<i className="fa fa-star"></i>
													</li>
													<li>
														<i className="fa fa-star"></i>
													</li>
													<li>
														<i className="fa fa-star"></i>
													</li>
													<li>
														<i className="fa fa-star"></i>
													</li>
													<li className="total-rating">
														<span>(2)</span>
													</li>
												</ul>
											</div>
											<h6>100g</h6>
											<h4>
												<span style={{ color: "#FA532C" }}>$2.5 </span>
												<strike style={{ color: "#666666", FontSize: "12px" }}>
													$7.5
												</strike>
											</h4>

											<div className="counter-total-wrapper">
												<input type="number" min={0} />
												<h6>
													Total: <span>$38.5</span>
												</h6>
											</div>
											<a href="#" className="btn">
												Add To Cart
											</a>
										</div>
									</div>
								</div>
								<div className="col-lg-3 px-0">
									<div className="product-card-wrapper">
										<div className="product-img-wrapper">
											<figure>
												<img src={arrival8} className="img-fluid" alt="" />
											</figure>
										</div>
										<div className="product-content-wrapper">
											<h5>Farmart</h5>
											<span className="ice">
												British Beef Mine (Typically 10% Fat)
											</span>
											<div className="rating-wrapper">
												<ul>
													<li>
														<i className="fa fa-star"></i>
													</li>
													<li>
														<i className="fa fa-star"></i>
													</li>
													<li>
														<i className="fa fa-star"></i>
													</li>
													<li>
														<i className="fa fa-star"></i>
													</li>
													<li>
														<i className="fa fa-star"></i>
													</li>
													<li className="total-rating">
														<span>(1)</span>
													</li>
												</ul>
											</div>
											<h6>454kg</h6>
											<h4>$96.90</h4>

											<div className="counter-total-wrapper">
												<input type="number" min={0} />
												<h6>
													Total: <span>$96.90</span>
												</h6>
											</div>
											<a href="#" className="btn">
												Add To Cart
											</a>
										</div>
									</div>
								</div>
								<div className="col-lg-3 px-0">
									<div className="product-card-wrapper">
										<div className="product-img-wrapper">
											<figure>
												<img src={arrival9} className="img-fluid" alt="" />
											</figure>
										</div>
										<div className="product-content-wrapper">
											<h5>Farmart</h5>
											<span className="ice">
												British Beef Mine (Typically 10% Fat)
											</span>
											<div className="rating-wrapper">
												<ul>
													<li>
														<i className="fa fa-star"></i>
													</li>
													<li>
														<i className="fa fa-star"></i>
													</li>
													<li>
														<i className="fa fa-star"></i>
													</li>
													<li>
														<i className="fa fa-star"></i>
													</li>
													<li>
														<i className="fa fa-star"></i>
													</li>
													<li className="total-rating">
														<span>(1)</span>
													</li>
												</ul>
											</div>
											<h6>454g</h6>
											<h4>$96.90</h4>

											<div className="counter-total-wrapper">
												<input type="number" min={0} />
												<h6>
													Total: <span>$96.90</span>
												</h6>
											</div>
											<a href="#" className="btn">
												Add To Cart
											</a>
										</div>
									</div>
								</div>
								<div className="col-lg-3 px-0">
									<div className="product-card-wrapper">
										<div className="product-img-wrapper">
											<figure>
												<img src={arrival2} className="img-fluid" alt="" />
											</figure>
											<div className="save-wrapper">
												<h6>Save 12%</h6>
											</div>
										</div>
										<div className="product-content-wrapper">
											<h5>MartFury</h5>
											<span className="ice">US Yellow Water Melon</span>
											<div className="rating-wrapper">
												<ul>
													<li>
														<i className="fa fa-star"></i>
													</li>
													<li>
														<i className="fa fa-star"></i>
													</li>
													<li>
														<i className="fa fa-star"></i>
													</li>
													<li>
														<i className="fa fa-star"></i>
													</li>
													<li>
														<i className="fa fa-star"></i>
													</li>
													<li className="total-rating">
														<span>(2)</span>
													</li>
												</ul>
											</div>
											<h6>2kg</h6>
											<h4>
												<span style={{ color: "#FA532C" }}>$59.50 </span>
												<strike style={{ color: "#666666", FontSize: "12px" }}>
													{" "}
													$69.70
												</strike>
											</h4>

											<div className="counter-total-wrapper">
												<input type="number" min={0} />
												<h6>
													Total: <span>$38.5</span>
												</h6>
											</div>
											<a href="#" className="btn">
												Add To Cart
											</a>
										</div>
									</div>
								</div>
								<div className="col-lg-3 px-0">
									<div className="product-card-wrapper">
										<div className="product-img-wrapper">
											<figure>
												<img src={arrival3} className="img-fluid" alt="" />
											</figure>
											<div className="save-wrapper">
												<h6>Save 34%</h6>
											</div>
										</div>
										<div className="product-content-wrapper">
											<h5>Farmart</h5>
											<span className="ice">Spicies Snacks 6 Ready Salted</span>
											<div className="rating-wrapper">
												<ul>
													<li>
														<i className="fa fa-star"></i>
													</li>
													<li>
														<i className="fa fa-star"></i>
													</li>
													<li>
														<i className="fa fa-star"></i>
													</li>
													<li>
														<i className="fa fa-star"></i>
													</li>
													<li>
														<i className="fa fa-star"></i>
													</li>
													<li className="total-rating">
														<span>(2)</span>
													</li>
												</ul>
											</div>
											<h6>100g</h6>
											<h4>
												<span style={{ color: "#FA532C" }}>$2.5 </span>
												<strike style={{ color: "#666666", FontSize: "12px" }}>
													$7.5
												</strike>
											</h4>

											<div className="counter-total-wrapper">
												<input type="number" min={0} />
												<h6>
													Total: <span>$38.5</span>
												</h6>
											</div>
											<a href="#" className="btn">
												Add To Cart
											</a>
										</div>
									</div>
								</div>
								<div className="col-lg-3 px-0">
									<div className="product-card-wrapper">
										<div className="product-img-wrapper">
											<figure>
												<img src={arrival8} className="img-fluid" alt="" />
											</figure>
										</div>
										<div className="product-content-wrapper">
											<h5>Farmart</h5>
											<span className="ice">
												British Beef Mine (Typically 10% Fat)
											</span>
											<div className="rating-wrapper">
												<ul>
													<li>
														<i className="fa fa-star"></i>
													</li>
													<li>
														<i className="fa fa-star"></i>
													</li>
													<li>
														<i className="fa fa-star"></i>
													</li>
													<li>
														<i className="fa fa-star"></i>
													</li>
													<li>
														<i className="fa fa-star"></i>
													</li>
													<li className="total-rating">
														<span>(1)</span>
													</li>
												</ul>
											</div>
											<h6>454kg</h6>
											<h4>$96.90</h4>

											<div className="counter-total-wrapper">
												<input type="number" min={0} />
												<h6>
													Total: <span>$96.90</span>
												</h6>
											</div>
											<a href="#" className="btn">
												Add To Cart
											</a>
										</div>
									</div>
								</div>
								<div className="col-lg-3 px-0">
									<div className="product-card-wrapper">
										<div className="product-img-wrapper">
											<figure>
												<img src={arrival9} className="img-fluid" alt="" />
											</figure>
										</div>
										<div className="product-content-wrapper">
											<h5>Farmart</h5>
											<span className="ice">
												British Beef Mine (Typically 10% Fat)
											</span>
											<div className="rating-wrapper">
												<ul>
													<li>
														<i className="fa fa-star"></i>
													</li>
													<li>
														<i className="fa fa-star"></i>
													</li>
													<li>
														<i className="fa fa-star"></i>
													</li>
													<li>
														<i className="fa fa-star"></i>
													</li>
													<li>
														<i className="fa fa-star"></i>
													</li>
													<li className="total-rating">
														<span>(1)</span>
													</li>
												</ul>
											</div>
											<h6>454g</h6>
											<h4>$96.90</h4>

											<div className="counter-total-wrapper">
												<input type="number" min={0} />
												<h6>
													Total: <span>$96.90</span>
												</h6>
											</div>
											<a href="#" className="btn">
												Add To Cart
											</a>
										</div>
									</div>
								</div>
								<div className="col-lg-3 px-0">
									<div className="product-card-wrapper">
										<div className="product-img-wrapper">
											<figure>
												<img src={arrival2} className="img-fluid" alt="" />
											</figure>
											<div className="save-wrapper">
												<h6>Save 12%</h6>
											</div>
										</div>
										<div className="product-content-wrapper">
											<h5>MartFury</h5>
											<span className="ice">US Yellow Water Melon</span>
											<div className="rating-wrapper">
												<ul>
													<li>
														<i className="fa fa-star"></i>
													</li>
													<li>
														<i className="fa fa-star"></i>
													</li>
													<li>
														<i className="fa fa-star"></i>
													</li>
													<li>
														<i className="fa fa-star"></i>
													</li>
													<li>
														<i className="fa fa-star"></i>
													</li>
													<li className="total-rating">
														<span>(2)</span>
													</li>
												</ul>
											</div>
											<h6>2kg</h6>
											<h4>
												<span style={{ color: "#FA532C" }}>$59.50 </span>
												<strike style={{ color: "#666666", FontSize: "12px" }}>
													{" "}
													$69.70
												</strike>
											</h4>

											<div className="counter-total-wrapper">
												<input type="number" min={0} />
												<h6>
													Total: <span>$38.5</span>
												</h6>
											</div>
											<a href="#" className="btn">
												Add To Cart
											</a>
										</div>
									</div>
								</div>
								<div className="col-lg-3 px-0">
									<div className="product-card-wrapper">
										<div className="product-img-wrapper">
											<figure>
												<img src={arrival3} className="img-fluid" alt="" />
											</figure>
											<div className="save-wrapper">
												<h6>Save 34%</h6>
											</div>
										</div>
										<div className="product-content-wrapper">
											<h5>Farmart</h5>
											<span className="ice">Spicies Snacks 6 Ready Salted</span>
											<div className="rating-wrapper">
												<ul>
													<li>
														<i className="fa fa-star"></i>
													</li>
													<li>
														<i className="fa fa-star"></i>
													</li>
													<li>
														<i className="fa fa-star"></i>
													</li>
													<li>
														<i className="fa fa-star"></i>
													</li>
													<li>
														<i className="fa fa-star"></i>
													</li>
													<li className="total-rating">
														<span>(2)</span>
													</li>
												</ul>
											</div>
											<h6>100g</h6>
											<h4>
												<span style={{ color: "#FA532C" }}>$2.5 </span>
												<strike style={{ color: "#666666", FontSize: "12px" }}>
													$7.5
												</strike>
											</h4>

											<div className="counter-total-wrapper">
												<input type="number" min={0} />
												<h6>
													Total: <span>$38.5</span>
												</h6>
											</div>
											<a href="#" className="btn">
												Add To Cart
											</a>
										</div>
									</div>
								</div>
							</div>
							<div className="pagination-wrapper">
								<ul>
									<li>
										<button>
											<i className="fa fa-angle-left"></i>
										</button>
									</li>
									<li>
										<span className="current">2</span>
									</li>
									<li>
										<span className="total">/10</span>
									</li>
									<li>
										<button>
											<i className="fa fa-angle-right"></i>
										</button>
									</li>
								</ul>
							</div>
						</div>
					</div>
				</div>
			</section>
			{/* products ends here */}
			{/* Footer starts here */}
			<Footer />
			{/* Footer ends here */}
		</>
	);
};

export default Shop;
